import { useEffect, useRef, useState } from "react";
import "../css/Weblog.css";
import { Link, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import { Button } from "primereact/button";
import Chip from "./Chip";
import { transparent } from "material-ui/styles/colors";
import { Toast } from "primereact/toast";
import { ConfirmDialog } from "primereact/confirmdialog";
import { apiClient } from "../apiClient";
import colors from '../colors';




function WeblogSidebar1(props)
{

    const [fetchedHorsePrs,setfetchedHorsePrs] = useState([]);
    const [fetchedRiderPrs,setfetchedRiderPrs] = useState([]);
    const [theme, setTheme] = useState(props.theme);
    const token = JSON.parse(localStorage.getItem('userToken'));
    const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
    const [searchValue,setSearchValue] = useState("");
    const [showSearchbox,setShowSearchbox] = useState(false);
    const [allproducts,setAllProducts] = useState([]);
    const [searchProductsLoading,setSearchProductsLoading] = useState(false);
    const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
    const navigate = useNavigate();
    const [selectedKeywords, setSelectedKeywords] = useState(props.secondryKeywords);
    const [selectedLinksToArticles,setSelectedLinksToArticles] = useState(props.internalLinkToArticles);
    const [internalLinksCreated,setInternalLinksCreated] = useState();
    const toast = useRef(null);
    const [isEditing, setIsEditing] = useState(false); 
    const [metaDescription, setMetaDescription] = useState(props.metaDescription); 
    const [tempDescription, setTempDescription] = useState(props.metaDescription); 
    const [watermark,setWatermark] = useState(props.creator);
    const [showConfirmWatermark,setShowConfirmWatermark] = useState(false);
    




    //watermark section: *******************************************************************************

     //get watermark:
     useEffect( () =>
      {
        
        if(props.creator?._id!==undefined)
          {
            
          apiClient.get(process.env.REACT_APP_BACK + "/users/getUserWatermark/" + props.creator?._id, config)
            .then(async(response) => {
  
              await setWatermark(response.data);
                
            })
            .catch((error) => {
              
            });
          }

  
      },[config]);

      const addWatermark = () =>
        {
            apiClient.get(process.env.REACT_APP_BACK + "/articles/add_watermark/" + props.article_id + "/" + watermark, config)
                .then((response) => {
                  toast.current.show({severity: 'success', summary:"واترمارک به تصاویر مقاله اضافه شد. لطفا تصاویر نهایی را تایید یا رد کنید" }); 
                  window.location.reload();
                    
                })
                .catch((error) => {
               
                });
    
        }

    const removewatermark = () =>
      {
          apiClient.get(process.env.REACT_APP_BACK + "/articles/remove_watermark/" + props.article_id, config)
              .then((response) => {
                  
                toast.current.show({severity: 'info', summary:"تصاویر مقاله به حالت اولیه بازگشت. در صورت تمایل می توانید تصویر واترمارک را تغییر داده و مجدد اعمال کنید" }); 
                window.location.reload();

              })
              .catch((error) => {
             
              });
  
      }
  
      const removeImagesbackup = () =>
      {
          apiClient.get(process.env.REACT_APP_BACK + "/articles/remove_image_backup/" + props.article_id, config)
              .then((response) => {

                toast.current.show({severity: 'info', summary:"تصاویر مقاله تایید شد" }); 
                window.location.reload();
                  
              })
              .catch((error) => {
                 
              });
  
      }

      /********************************************************************************* */
  



      /* meta section *******************************************************************/

      // get meta:
    useEffect(() => {
      setMetaDescription(props.metaDescription);
      setTempDescription(props.metaDescription);
    }, [props.metaDescription]); 

    // Enter meta edit mode
    const handleEditClick = () => {
      setIsEditing(true);
    };

    // Handle changes in the meta text field
    const handleInputChange = (e) => {
      setTempDescription(e.target.value);
    };

    // Confirm meta edit and save changes
    const handleConfirm = () => {
      setMetaDescription(tempDescription);
      setIsEditing(false);
      editMeta(tempDescription); // Call the editMeta function with the new value
    };

    // Cancel meta edit and revert changes
    const handleCancel = () => {
      setTempDescription(metaDescription); // Reset temporary value
      setIsEditing(false);
    };
    /**************************************************************************************** */
    

    
    /* rank section: ****************************************************************************************/
    const calculateRank = async (keyword) =>
      {
        await apiClient.get(process.env.REACT_APP_BACK+"/articles/calculate_rank/"+props.keyword, config)
        .then(response => 
          {
            if (response.status == 200)
            {
              if(response.data !=="error")
                toast.current.show({severity: 'info', summary:"رتبه گوگل آپدیت شد" }); 
              else
                toast.current.show({severity: 'error', summary:"تعداد درخواست مجاز برای امروز پر شده است" }); 
              
              
            }
  
        })
        .catch(error => {
           console.log(error);
           
        });
      }
      /********************************************************************************************************* */

    
      /* internal link section: ********************************************************************************/

      //get secondry keywords:
      useEffect( () =>
        {
              setSelectedKeywords(props.secondryKeywords);
    
        },[props.secondryKeywords]);

        //get related articles:
      useEffect( () =>
        {
          
              setSelectedLinksToArticles(props.internalLinkToArticles ? props.internalLinkToArticles : []);
              setInternalLinksCreated(props.internalLinksCreated);
              
    
        },[watermark]);
  
        
        // update secondry keywords:
    const updateSecondryKeyword = async (event) =>
      {
          if (event.key === 'Enter') {
  
              //prevent form submitting:
              event.preventDefault(); 
              event.stopPropagation(); 
  
              let newsecondryKeywords = formik.values["secondryKeywords"].split('-').map(element => ({
                  [element.trim()]: 0
                }));
      
              
                const data = selectedKeywords.concat(newsecondryKeywords);
                await apiClient.patch(process.env.REACT_APP_BACK + "/articles/updateKeywords/"+props.article_id, data, config)
                  .then((res) => {
                      setSelectedKeywords(data);
                      formik.setFieldValue("secondryKeywords","");
                  })
                  .catch((error) => {
                   
                  });
                
  
              
          }
          
      }
  
    //update related articles:
    useEffect(() => {
      async function saveRelatedArticles() {

        
        const data = JSON.stringify(selectedLinksToArticles);
        await apiClient.patch(process.env.REACT_APP_BACK + "/articles/updateRelatedArticles/"+props.article_id, data, config)
                      .then((res) => {
                          
                
                          
                      })
                      .catch((error) => {
                        
                      });
        }
      
       
      
        if( props.article_id)
          saveRelatedArticles();

    }, [selectedLinksToArticles]); 


          const deleteSecondryKeyword = async(keyword) =>
          {
             
                      const data = selectedKeywords.filter((k) => {
                          const keyName = Object.keys(k)[0]; // Get the dynamic key name
                          return keyName !== keyword;
                      });
                    
                    await apiClient.patch(process.env.REACT_APP_BACK + "/articles/updateKeywords/"+props.article_id, data, config)
                      .then((res) => {
                          
                          setSelectedKeywords(data);
                          
                      })
                      .catch((error) => {
                       
                      });
              
              
          }

    //auto complete secondry keywords:
    const findSecondryKeywords = async (keyword) =>
      {

        

          await apiClient.get(process.env.REACT_APP_BACK+"/sitemap/find_secondry_keywords/"+keyword, config)
              .then((result) => {
                if (result.status == 200) {

                  

                  let secondryKeywordsString=result.data.join('-');
                  if(secondryKeywordsString==="")
                    toast.current.show({severity: 'error', summary:"گوگل کلمه مشابهی را پیشنهاد نداد" }); 
                  else
                    formik.setFieldValue("secondryKeywords" , secondryKeywordsString);
                    
                          
                  return result.data;
                }
              })
              .catch((error) => {
                console.log(error);
               
              })
      }

      const createInternalLinks = async () =>
      {
       
        // is related articles selected:
        if(!internalLinksCreated && selectedLinksToArticles && selectedLinksToArticles.length !=0)
        {
          await props.createInternalLinks(selectedLinksToArticles);
          toast.current.show({ severity: 'info', summary: "لینک های داخلی به متن مقاله اضافه شد" });
          
          setTimeout(() => {
            window.location.reload();
            }, 3000);
          
        }
        else
          await toast.current.show({severity: 'error', summary:"لطفا ابتدا مقاله های مرتبط را انتخاب کنید" }); 
          
      
          
          
      }

      

      /************************************************************************************************************ */

      

       const formik = useFormik({
              initialValues: {
                
              },
              validate: (values) => {
                
              },
              onSubmit: (values) => {
                  submitPost(values);
                  return;
              },
          });

          const submitPost = async (values) => {

    
            
    
            var data = {secondryKeywords:selectedKeywords,};
            data = JSON.stringify(data);
    
            //creating article in database
            apiClient
                .patch(process.env.REACT_APP_BACK + "/articles/" + props.article_id,data, config)
                .then((response) => {
                    navigate("/weblog/"+props.article_id);
                })
                .catch((error) => {
                   
                });
        }


        const editMeta = (metaDescription) =>
        {
          const data = { metaDescription };
    
          apiClient.patch(process.env.REACT_APP_BACK + "/articles/editMeta/" + props.article_id,data, config)
              .then((response) => {
                  
              })
              .catch((error) => {
                
              });
        }





    return(
        <div id="weblogsidebar1" >

          

          <Toast ref={toast} position="center"></Toast>

      {/* confirm dialog for watermark: */}

          <ConfirmDialog
                    className={theme}
                    visible={showConfirmWatermark}
                    onHide={() => setShowConfirmWatermark(false)}
                    message="آیا از تایید تصاویر مقاله مطمئنید؟ پس از تایید امکان برداشتن واترمارک وجود ندارد!"
                    header="تایید واترمارک"
                    icon="pi pi-info-circle"
                    acceptLabel="بله"
                    rejectLabel="نه"
                    accept={removeImagesbackup}
                    reject={() => setShowConfirmWatermark(false)}
                />

            <div className="no-scrol sidebar_container">

                <p style={{textAlign:"right",marginBottom:'0px'}}>:کلمه کلیدی</p>
                <h4 style={{textAlign:"right",marginBottom:'30px'}}>{props.keyword}</h4>


              
                

                <div id="riderSection">

                <h3 className="title">کلمات کلیدی فرعی  </h3>

                <div style={{ direction: 'rtl', marginBottom: '30px', alignItems: 'center' }}>
                                       
                                        <span style={{fontSize:"12px",float:'right',marginBottom:'10px',textAlign:'right',color:"#404040c2"}}>(اعداد روبروی هر کلید فرعی، تعداد لینک داخلی به آن را نشان می دهند)</span>
                                        
                                        <span id="keyword-selections" >
                                            
                                            {selectedKeywords?.map((item,index) =>(
                                                <span  key={index} className="user-item" style={{display:"flex",alignItems:"center",direction:"rtl", cursor:'auto'}}>
                                                  <i className="pi pi-times-circle" style={{marginLeft:'5px',cursor:'pointer'}} onClick={()=>deleteSecondryKeyword(Object.keys(item)[0])}></i>
                                                   {Object.keys(item) + ": "+ Object.values(item)}
                                                </span>    
                                            ))}
                
                                        </span>
                                        
                                        
                                        <InputText
                                            style={{ display: "flex", width: "100%" }}
                                            id="secondryKeywords"
                                            name="secondryKeywords"
                                            placeholder="با - جدا کنید ، با enter تایید کنید"
                                            value={formik.values.secondryKeywords}
                                            onChange={formik.handleChange}
                                            onKeyDown={updateSecondryKeyword}
                                            maxLength={1000}
                                        />
                                        <span 
                                            style={{textAlign:"center", fontSize:'12px', color:colors.primary,display:"flex", marginTop:"15px", cursor:"pointer",fontFamily: 'peyda-extra-bold' }}
                                            onClick={() => findSecondryKeywords(props.keyword)}    
                                            >از پیشنهادات گوگل استفاده کن </span>
                                    </div>
                


             

                </div>

                <div id="horseSection">

                <h3 className="title">لینک سازی داخلی </h3>
                <div style={{ direction: 'rtl', marginBottom: '30px', alignItems: 'center' }}>
                        <span style={{ display: "flex", width: "fit-content",fontSize:"12px", marginBottom:"10px",marginTop:"10px",textAlign:"right",color:"#404040c2" }}>
                           مقاله هایی که می خواهید به آنها لینک داخلی بدهید را وارد کنید. لینک روی کلمات فرعی آنها اعمال می شود
                        </span>

                        <p style={{textAlign:'right',marginBottom:'0px',marginTop:'30px'}}>مقاله های مرتبط:</p>

                        
                        <Chip
                                    article_id={props.article_id}
                                    user_id={props.creator?._id}
                                    for={props.for}
                                    name="internalLinkToArticles"
                                    type="internalLinkToArticles"
                                    setSelections={setSelectedLinksToArticles}
                                    selections={selectedLinksToArticles}
                                />
                               
                        
                    </div>

                    <div style={{textAlign:'right', marginBottom:'30px', direction:'rtl',marginBottom:'50px'}}>
                                            
                                            <span 
                                             style={{cursor: !internalLinksCreated ?'pointer' : null , marginLeft:'10px' ,
                                                backgroundColor: !internalLinksCreated ?'#219B9D' : transparent , color: !internalLinksCreated ? '#ffffff' : "#219B9D ", 
                                                border:"1px #219B9D solid" , borderRadius:'10px' , padding:'10px'}}
                                                onClick={ !internalLinksCreated ? createInternalLinks : null}
                                             >
                                                {!internalLinksCreated ? "لینک های داخلی را بساز" : "لینک های داخلی ساخته شده" }
                                               </span>
                                            
                    
                                        </div>

               

                </div>


                <div id="horseSection">
                <span style={{ display: 'flex', alignItems: 'center', direction: 'rtl' }}>
                  <h3 className="title" style={{ display: 'flex', width: '50%' }}>توضیحات متا</h3>
                  <i
                    className="pi pi-pencil"
                    style={{
                      display: 'flex',
                      width: '50%',
                      direction: 'ltr',
                      color: '#4040409c',
                      cursor: 'pointer'
                    }}
                    onClick={handleEditClick}
                  />
                </span>

                <div style={{ textAlign: 'right' }}>
                  {isEditing ? (
                    // Editable mode
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                      <textarea
                        value={tempDescription}
                        onChange={handleInputChange}
                        style={{ width: '100%', marginBottom: '10px' }}
                        maxLength={150}
                        rows="5" cols="30"
                      />
                      <div>
                        <button 
                          onClick={handleCancel}
                          style={{background: transparent,border: "1px solid rgba(0, 0, 0, 0.12)",borderRadius: "10px",padding: "5px 20px",cursor: "pointer"}}
                        >لغو</button>
                        <button 
                          onClick={handleConfirm} 
                          style={{marginLeft:"10px",border: "1px solid rgba(0, 0, 0, 0.12)",borderRadius: "10px",padding: "5px 20px",cursor: "pointer"}}
                          >تأیید</button>
                      </div>
                    </div>
                  ) : (
                    // Read-only mode
                    <p style={{wordWrap: 'break-word'}}>{metaDescription}</p>
                    
                  )}
                </div>


              </div>

                <div id="tagsSection">

                <h3 className="title">رتبه گوگل</h3>

                <span style={{ display: "flex", width: "fit-content",fontSize:"12px", marginBottom:"10px",marginTop:"10px",textAlign:"right",color:"#404040c2" }}>
                           رتبه گوگل بصورت دوره ای آپدیت می شود. دقت کنید که عدد نشان داده شده توسط کتابخانه گوگل محاسبه شده است و بنا به تنظیمات و مکان جغرافیایی مرورگر شما می تواند کمی متفاوت باشد
                            - (رتبه های بالای 30 نمایش داده نمی شود)
                        </span>
                  
                
                            {props.rank!==undefined ? <div style={{display:"flex", alignItems:"center"}}>
                                {( props.rank<10) && 
                                (<i className="pi pi-star-fill" 
                                  style={{background: "green",borderRadius: "15px",width:"30px",height:"30px",padding: "10px",color: "#fff", fontSize:"11px",display:"flex",alignItems:"center"}}>
                                </i>)}
                            <Button 
                              tooltip="آپدیت رتبه گوگل" tooltipOptions={{position:"top"}}
                              style={{color: props.rank >= 20 ? "red" : "green", fontSize:"20px",cursor:"pointer",background:'transparent',border:"none"}}
                              onClick={() => calculateRank(props.keyword)}
                                >{props.rank}</Button>
                              </div> 
                        :
                          <Button 
                                  tooltip="محاسبه رتبه گوگل" tooltipOptions={{position:"top"}}
                                  style={{color:"red", fontSize:"20px",cursor:"pointer",background:'transparent',border:"none"}}
                                  onClick={() => calculateRank(props.keyword)}
                                    >؟</Button> }

                          <div>
               
                    
                    </div>

                </div>


                <div id="tagsSection">

                <h3 className="title">واترمارک تصاویر</h3>

                <div className="watermark_pic">

                { watermark ? 

              <div className="watermark-container">
                <img 
              src={`${process.env.REACT_APP_BACK}/watermarks/${watermark}`}
              alt={process.env.REACT_APP_ALT}
              />
              <div className="edit-watermark">
              <i className="pi pi-camera" onClick={() => navigate("/dashboard/watermark")}></i>
              </div>
              </div>
                
                :

                <div>
                   <i
                  className="pi pi-camera"
                  onClick={() => navigate("/dashboard/watermark")}
                  style={{
                    marginTop: "40%",
                    fontSize: "50px",
                    color: colors.primary,
                    border: "3px solid #219B9D",
                    borderRadius:"50%",
                    padding: "30px",
                    cursor:"pointer"
                  }}
                ></i>
                <p> لطفا تصویر واترمارک خود را انتخاب کنید</p>
                </div>
              }


              

              </div>


              {watermark ? 
              
              <div style={{textAlign:'center', marginTop:'30px', direction:'rtl',marginBottom:'50px'}}>
                                            
              

                 {!props.imagesHasWatermark && (<span onClick={addWatermark}
                         style={{cursor:'pointer'  , marginLeft:'10px' ,
                          backgroundColor:  transparent , color:  colors.primary, 
                          border:"1px #219B9D solid" , borderRadius:'10px' , padding:'10px'}}>
                          اضافه کردن واترمارک به تصاویر
                          </span>)}

                
              

            </div>
            
                : null
            }


      {(props.imagesHasWatermark && props.imagesHasBackup) &&
            (<div>

            <p style={{marginTop:'30px'}}>
              واترمارک اعمال شده مورد تایید است؟
            </p>

            <span style={{display:'table',margin:"auto", direction:'rtl'}}>

            {/* watermark is approuved: */}
            <i className="pi pi-check watermark-accept" 
            onClick={() => setShowConfirmWatermark(true)}
            ></i>
            
            {/* watermark is not approved: */}
            <i className="pi pi-times watermark-cancel" 
            onClick={removewatermark}
            ></i>

            </span>

            </div>) }

             
                  
                
                          

                          <div>
               
                    
                    </div>

                </div>

            </div>

           

        </div>
    );
}

export default WeblogSidebar1;